export default __webpack_public_path__ + "static/media/skillsLaunchpad_Btn.d03f541e.png";